<template>
  <div class="row mt-4" v-if="campanas.length">
    <div class="col-12">
      <div class="card ficha-listado">
        <div class="px-4 pb-4 card-body">

          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
              <h6 class="mb-0">Ranking de campañas</h6>
              <p class="text-xs opacity-7 mb-0">Top campañas por captación y retención de suscriptores</p>
            </div>
            <div class="btn-group btn-group-sm" role="group">
              <button
                v-for="o in ordenOpciones"
                :key="o.key"
                class="btn btn-sm mb-0"
                :class="orden === o.key ? 'btn-activo' : 'btn-inactivo'"
                @click="orden = o.key"
              >{{ o.label }}</button>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-sm rk-table">
              <thead>
                <tr>
                  <th class="text-center" style="width:36px">#</th>
                  <th>Campaña</th>
                  <th>Tipster</th>
                  <th>Canal</th>
                  <th class="text-center">Entradas</th>
                  <th class="text-center">Suscritos</th>
                  <th class="text-center">Bajas</th>
                  <th style="min-width:120px" title="Verde ≥70% · Naranja ≥40% · Rojo &lt;40% · Calculada como suscriptores actuales / entradas únicas">Retención</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(c, idx) in campanasSorted" :key="c.campana_id">
                  <td class="text-center">
                    <span class="rk-pos" :class="posClass(idx)">{{ idx + 1 }}</span>
                  </td>
                  <td class="rk-nombre" :title="c.campana_nombre || ''">{{ c.campana_nombre || '—' }}</td>
                  <td class="rk-tipster">{{ c.tipster_nombre }}</td>
                  <td class="rk-canal text-xs">{{ c.canal_nombre }}</td>
                  <td class="text-center fw-bold">
                    <span class="stat-cell" @click.stop="abrirDetalle(c.campana_id, 'entradas', c.campana_nombre)">
                      {{ c.entradas_total }}<i class="fas fa-eye ms-1"></i>
                    </span>
                  </td>
                  <td class="text-center">
                    <span class="stat-cell rk-suscritos" @click.stop="abrirDetalle(c.campana_id, 'suscripciones', c.campana_nombre)">
                      {{ c.suscritos_actuales }}<i class="fas fa-eye ms-1"></i>
                    </span>
                  </td>
                  <td class="text-center">
                    <span v-if="c.salidas_total > 0" class="stat-cell rk-bajas" @click.stop="abrirDetalle(c.campana_id, 'salidas', c.campana_nombre)">
                      {{ c.salidas_total }}<i class="fas fa-eye ms-1"></i>
                    </span>
                    <span v-else class="text-muted">0</span>
                  </td>
                  <td>
                    <template v-if="c.tasa_ret === null">
                      <span class="text-muted">—</span>
                    </template>
                    <div v-else class="rk-bar-row">
                      <div class="rk-bar-track">
                        <div
                          class="rk-bar-fill"
                          :class="colorRetBar(c.tasa_ret)"
                          :style="{ width: c.tasa_ret + '%' }"
                        ></div>
                      </div>
                      <span class="rk-pct" :class="colorRet(c.tasa_ret)">{{ c.tasa_ret }}%</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p v-if="orden === 'bajas'" class="text-xs mt-2 mb-0 rk-nota-bajas">
            ⚠️ Ordenado por mayor número de bajas — las campañas con más bajas aparecen primero
          </p>
          <p v-if="campanas.length > limit" class="text-xs opacity-5 mt-2 mb-0 text-end">
            Mostrando top {{ limit }} de {{ campanas.length }} campañas
          </p>

        </div>
      </div>
    </div>
  </div>
  <!-- Modal detalle campaña -->
  <teleport to="body">
    <div v-if="detalle.visible" class="overlay" @click.self="detalle.visible=false">
      <div class="detalle-box" :class="'detalle-tipo-' + detalle.tipo">

        <div class="detalle-header">
          <div class="detalle-header-left">
            <span class="detalle-tipo-dot"></span>
            <div>
              <div class="detalle-titulo">{{ detalle.titulo }}</div>
              <div v-if="!detalle.loading" class="detalle-subtitulo">
                {{ detalle.filas.length }} {{ detalle.filas.length === 1 ? 'registro' : 'registros' }}
              </div>
            </div>
          </div>
          <div class="detalle-header-actions">
            <button class="detalle-cerrar" @click="detalle.visible=false">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>

        <div class="detalle-body">
          <div v-if="detalle.loading" class="detalle-loading">
            <div class="detalle-spinner"></div>
            <span>Cargando...</span>
          </div>

          <div v-else-if="detalle.filas.length === 0" class="detalle-empty">
            <i class="fas fa-inbox detalle-empty-icon"></i>
            <p>Sin registros para esta campaña</p>
          </div>

          <div v-else class="table-responsive">
            <table class="table table-sm table-flush detalle-tabla">
              <thead>
                <tr>
                  <th v-for="col in detalle.cols" :key="col.key">{{ col.label }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(fila, i) in detalle.filas" :key="i">
                  <td v-for="col in detalle.cols" :key="col.key">
                    <template v-if="col.key === 'telegram_username'">
                      <span v-if="fila[col.key]" class="detalle-username">@{{ fila[col.key] }}</span>
                      <span v-else class="text-muted">—</span>
                    </template>
                    <template v-else-if="col.tipo === 'fecha'">{{ fila[col.key] ? fmtDate(fila[col.key]) : '—' }}</template>
                    <template v-else>{{ fila[col.key] ?? '—' }}</template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  </teleport>

</template>

<script>
export default {
  name: "PanelPublicistaRanking",
  props: {
    tipsters: { type: Array, default: () => [] },
    limit: { type: Number, default: 15 },
  },
  data() {
    return {
      orden: "suscritos",
      ordenOpciones: [
        { key: "suscritos", label: "Suscritos" },
        { key: "entradas",  label: "Entradas" },
        { key: "ret",       label: "Retención" },
        { key: "bajas",     label: "Bajas" },
      ],
      detalle: { visible: false, loading: false, tipo: '', titulo: '', filas: [], cols: [] },
    };
  },
  computed: {
    campanas() {
      const list = [];
      for (const t of this.tipsters) {
        for (const c of t.campanas || []) {
          const entradas = c.entradas_unicas || c.usuarios_unicos || 0;
          const tasa = entradas > 0
            ? parseFloat(((c.suscritos_actuales / entradas) * 100).toFixed(1))
            : (c.suscritos_actuales > 0 ? null : 0);
          list.push({ ...c, tipster_nombre: t.tipster_nombre, tasa_ret: tasa });
        }
      }
      return list;
    },
    campanasSorted() {
      const arr = [...this.campanas];
      if (this.orden === "suscritos") arr.sort((a, b) => b.suscritos_actuales - a.suscritos_actuales);
      if (this.orden === "entradas")  arr.sort((a, b) => b.entradas_total - a.entradas_total);
      if (this.orden === "ret")       arr.sort((a, b) => b.tasa_ret - a.tasa_ret);
      if (this.orden === "bajas")     arr.sort((a, b) => b.salidas_total - a.salidas_total);
      return arr.slice(0, this.limit);
    },
  },
  methods: {
    posClass(idx) {
      if (idx === 0) return "rk-pos--gold";
      if (idx === 1) return "rk-pos--silver";
      if (idx === 2) return "rk-pos--bronze";
      return "";
    },
    colorRet(pct) {
      if (pct >= 70) return "text-success fw-bold";
      if (pct >= 40) return "text-warning fw-bold";
      if (pct > 0)   return "text-danger fw-bold";
      return "text-muted";
    },
    colorRetBar(pct) {
      if (pct >= 70) return "rk-bar-fill--verde";
      if (pct >= 40) return "rk-bar-fill--naranja";
      if (pct > 0)   return "rk-bar-fill--rojo";
      return "rk-bar-fill--gris";
    },

    fmtDate(str) {
      if (!str) return '—';
      const d = new Date(str);
      if (isNaN(d)) return str;
      const p = n => String(n).padStart(2, '0');
      return `${p(d.getDate())}/${p(d.getMonth()+1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
    },

    async abrirDetalle(campanaId, tipo, campanaNombre) {
      const tipSufijo = campanaNombre ? ` — ${campanaNombre}` : '';
      const titulos = {
        suscripciones: `Suscriptores activos${tipSufijo}`,
        entradas:      `Entradas${tipSufijo}`,
        salidas:       `Salidas${tipSufijo}`,
      };
      const colsMap = {
        suscripciones: [
          { key: 'telegram_id',       label: 'ID Telegram' },
          { key: 'nombre',            label: 'Nombre' },
          { key: 'telegram_username', label: 'Nick Telegram' },
          { key: 'fecha',             label: 'Fecha entrada', tipo: 'fecha' },
          { key: 'reingresos',        label: 'Reingresos' },
        ],
        entradas: [
          { key: 'telegram_id',       label: 'ID Telegram' },
          { key: 'nombre',            label: 'Nombre' },
          { key: 'telegram_username', label: 'Nick Telegram' },
          { key: 'fecha_entrada',     label: 'Fecha entrada', tipo: 'fecha' },
          { key: 'reingresos',        label: 'Reingresos' },
        ],
        salidas: [
          { key: 'telegram_id',       label: 'ID Telegram' },
          { key: 'nombre',            label: 'Nombre' },
          { key: 'telegram_username', label: 'Nick Telegram' },
          { key: 'fecha_entrada',     label: 'Fecha entrada', tipo: 'fecha' },
          { key: 'fecha_salida',      label: 'Fecha salida',  tipo: 'fecha' },
        ],
      };
      this.detalle = { visible: true, loading: true, tipo, titulo: titulos[tipo] || tipo, filas: [], cols: colsMap[tipo] || [] };
      try {
        const resp = await this.$store.dispatch('auth/campanaDetalle', { campana_id: campanaId, tipo });
        this.detalle.filas = resp.data || [];
      } catch (e) {
        this.detalle.filas = [];
      } finally {
        this.detalle.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.btn-inactivo {
  background: var(--q-card); color: var(--q-muted);
  border: 1px solid var(--q-border); border-radius: 8px !important;
  font-size: 11px; font-weight: 600; padding: 4px 10px; transition: .15s;
}
.btn-inactivo:hover { background: var(--q-hover); color: var(--q-gold); }
.btn-activo {
  background: linear-gradient(90deg, var(--q-gold), var(--q-gold-hover));
  color: var(--q-gold-on) !important; border:1px solid transparent !important;
  border-radius:8px !important; font-size:11px; font-weight:700; padding:4px 10px;
}

/* Tabla */
.rk-table { font-size: 12px; border-collapse: collapse; }
.rk-table th,
.rk-table td { border: none !important; box-shadow: none !important; }
.rk-table thead th {
  font-size: 10px; text-transform: uppercase; color: var(--q-muted);
  font-weight: 600; border-bottom: 1px solid var(--q-border) !important; padding: 4px 8px;
}
.rk-table tbody td { padding: 8px 8px; border-bottom: 1px solid var(--q-border) !important; vertical-align: middle; }

/* Posición */
.rk-pos {
  display: inline-flex; align-items: center; justify-content: center;
  width: 22px; height: 22px; border-radius: 50%;
  font-size: 11px; font-weight: 800;
  background: var(--q-hover); color: var(--q-muted);
}
.rk-pos--gold   { background: var(--q-amber-soft); color: var(--q-amber); }
.rk-pos--silver { background: var(--q-hover); color: var(--q-muted); }
.rk-pos--bronze { background: rgba(180,100,30,.15); color: #b4641e; }

.rk-nombre  { font-weight: 700; color: var(--q-text); max-width: 160px; }
.rk-tipster { color: var(--q-gold); font-weight: 600; font-size: 11px; }
.rk-canal   { color: var(--q-muted); }

.rk-suscritos { color: var(--q-green); font-weight: 700; }
.rk-bajas     { color: var(--q-red); font-weight: 700; }

/* Barra retención */
.rk-bar-row { display: flex; align-items: center; gap: 6px; }
.rk-bar-track {
  flex: 1; height: 7px; background: var(--q-hover);
  border-radius: 6px; overflow: hidden;
}
.rk-bar-fill { height: 100%; border-radius: 6px; transition: width .4s ease; }
.rk-bar-fill--verde   { background: linear-gradient(90deg, var(--q-green), #66bb6a); }
.rk-bar-fill--naranja { background: linear-gradient(90deg, var(--q-amber), #ffa726); }
.rk-bar-fill--rojo    { background: linear-gradient(90deg, var(--q-red), #ef9a9a); }
.rk-bar-fill--gris    { background: var(--q-border); }
.rk-pct { font-size: 11px; font-weight: 700; min-width: 36px; text-align: right; }

/* ── Botón ojo ── */
.stat-cell {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
.stat-cell .fa-eye {
  font-size: 0.72rem;
  opacity: 0.4;
  transition: opacity .15s;
}
.stat-cell:hover .fa-eye { opacity: 1; color: var(--q-primary, #00e676); }

/* ── Modal detalle ── */
.detalle-box {
  background: var(--q-card-bg, #1a1f2b);
  border: 1px solid var(--q-border, rgba(255,255,255,.1));
  border-radius: 14px;
  width: min(94vw, 760px);
  max-height: 82vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0,0,0,.55);
  overflow: hidden;
}

.detalle-tipo-entradas    { border-top: 3px solid #3b82f6; }
.detalle-tipo-suscripciones { border-top: 3px solid #10b981; }
.detalle-tipo-salidas     { border-top: 3px solid #6b7280; }

.detalle-tipo-entradas    .detalle-tipo-dot { background: #3b82f6; }
.detalle-tipo-suscripciones .detalle-tipo-dot { background: #10b981; }
.detalle-tipo-salidas     .detalle-tipo-dot { background: #6b7280; }

.detalle-tipo-dot {
  width: 10px; height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 3px;
}
.detalle-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--q-border, rgba(255,255,255,.08));
  background: var(--q-surface-alt, rgba(0,0,0,.15));
}
.detalle-header-left { display: flex; align-items: flex-start; gap: 0.6rem; }
.detalle-titulo { font-weight: 700; font-size: 0.97rem; line-height: 1.2; }
.detalle-subtitulo { font-size: 0.75rem; color: var(--q-text-muted, #888); margin-top: 2px; }
.detalle-header-actions { display: flex; align-items: center; gap: 0.5rem; }
.detalle-cerrar {
  background: none; border: none; cursor: pointer;
  color: var(--q-muted, #888); font-size: 1rem; padding: 4px 6px;
  border-radius: 6px; line-height: 1;
  transition: background .15s, color .15s;
}
.detalle-cerrar:hover { background: rgba(255,255,255,.08); color: var(--q-text); }

.detalle-body { overflow-y: auto; padding: 1rem 1.25rem; flex: 1; }

.detalle-loading {
  display: flex; flex-direction: column; align-items: center;
  gap: 0.75rem; padding: 2.5rem 0; color: var(--q-muted, #888); font-size: 0.85rem;
}
.detalle-spinner {
  width: 28px; height: 28px;
  border: 3px solid rgba(255,255,255,.1);
  border-top-color: var(--q-primary, #00e676);
  border-radius: 50%;
  animation: rk-spin .7s linear infinite;
}
@keyframes rk-spin { to { transform: rotate(360deg); } }

.detalle-empty {
  display: flex; flex-direction: column; align-items: center;
  gap: 0.5rem; padding: 2.5rem 0; color: var(--q-text-muted, #888);
}
.detalle-empty-icon { font-size: 2rem; opacity: 0.3; }
.detalle-empty p { margin: 0; font-size: 0.85rem; }

.detalle-tabla { font-size: 0.82rem; border-collapse: separate; border-spacing: 0; width: 100%; }
.detalle-tabla thead th {
  font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: .05em;
  color: var(--q-text-muted, #888);
  border-bottom: 1px solid var(--q-border, rgba(255,255,255,.08));
  padding: 0.5rem 0.75rem; white-space: nowrap;
}
.detalle-tabla tbody tr { transition: background .12s; }
.detalle-tabla tbody tr:hover { background: var(--q-surface-alt, rgba(255,255,255,.04)); }
.detalle-tabla tbody td {
  padding: 0.55rem 0.75rem;
  border-bottom: 1px solid var(--q-border, rgba(255,255,255,.05));
  vertical-align: middle; white-space: nowrap;
}
.detalle-tabla tbody tr:last-child td { border-bottom: none; }

.rk-nota-bajas {
  color: var(--q-amber, #f5a623);
  background: rgba(245,166,35,.08);
  border: 1px solid rgba(245,166,35,.2);
  border-radius: 8px;
  padding: 6px 12px;
}

.detalle-username {
  font-size: 0.78rem; color: var(--q-primary, #00e676);
  background: rgba(0,230,118,.08); border-radius: 4px; padding: 1px 6px;
}
</style>
